import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBarcodeRead } from "@fortawesome/pro-regular-svg-icons";
import ReactTooltip from "react-tooltip";

const ItemPackageBarCode = ({ itemPackage }) => {
  return (
    <>
      <FontAwesomeIcon
        icon={faBarcodeRead}
        className="transform hover:scale-110"
        data-tip
        data-for={`itemPackageBarCode_${itemPackage.id}`}
      />
      <ReactTooltip id={`itemPackageBarCode_${itemPackage.id}`} effect="solid">
        <span>{itemPackage.barCode}</span>
      </ReactTooltip>
    </>
  );
};

export default ItemPackageBarCode;
